import script from "./adminCashPage.vue?vue&type=script&setup=true&lang=js"
export * from "./adminCashPage.vue?vue&type=script&setup=true&lang=js"

import "./adminCashPage.vue?vue&type=style&index=0&id=948a6a00&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-948a6a00"]])

export default __exports__